import { Scene, FullScreenBackgroundFill } from "onearm";

export class ErrorMessagePopupScene extends Scene {
    constructor(parameters) {
        super({ layer: "popups", name: "ErrorMessagePopupScene", ...parameters });
    }

    create(options) {
        super.create(options);

        const {
            screen,
            title = "MESSAGE",
            message = "",
            showCloseButton = true,
            showReloadButton = true,
        } = options;

        this.fill = this.addChildAt(
            new FullScreenBackgroundFill({
                fullScreenZone: screen.zone.fullScreen,
                color: 0x000000,
                alpha: 0.8,
            }),
        0);

        this._closeButton = this.layout.find("CloseButton");
        this._reloadButton = this.layout.find("ReloadButton");
        this._errorText = this.layout.find("ErrorText");
        this._popupTitle = this.layout.find("PopupTitle");

        if (this._popupTitle) this._popupTitle.text = title;
        if (this._errorText) this._errorText.text = message;

        if (this._closeButton && !showCloseButton) {
            this._closeButton.visible = false;
        }
        if (this._reloadButton && !showReloadButton) {
            this._reloadButton.visible = false;
        }
    }

    get onPressClose() {
        return this._closeButton?.onPress;
    }

    get onPressReload() {
        return this._reloadButton?.onPress;
    }
}
